import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import formatHTML from 'utils/formatHTML';
import useSmartlook from 'hooks/useSmartlook';

// SECCI stands for Standard European Consumer Credit Information
export function useSecciQuery() {
  const { error } = useSmartlook();
  return useQuery<string>({
    queryKey: ['secci'],
    queryFn: async () => {
      try {
        const res = await fetchData(`/client/application/secci-html`, {
          headers: {
            'Content-Type': 'text/html',
          },
        });

        return formatHTML(res);
      } catch (e) {
        error('[useSecciQuery][GET /client/application/secci-html]', e);
        throw e;
      }
    },
    staleTime: Infinity,
  });
}

export function useSecciPDFQuery({ enabled = true }: { enabled?: boolean }) {
  const { error } = useSmartlook();
  return useQuery<Blob | null>({
    queryKey: ['secciPdf'],
    queryFn: async () => {
      try {
        const res = await fetchData(`/client/application/secci`, {
          headers: {
            'Content-Type': 'application/pdf',
          },
        });

        return res;
      } catch (e) {
        error('[useSecciPDFQuery][GET /client/application/secci]', e);
        throw e;
      }
    },
    staleTime: Infinity,
    enabled,
  });
}
